export class ProductPolicyRequestDto {

	country: string;
	user: string;
	policyDescription: string;
	policyName: string;
	productId: number;
	coverageCategoryId: number;
	saleType: number;
	isActive: number;
	vinCategoryVersionId: number;
	months: number;
	clientType: number;
	customerPriceId:number;
	fordCostPriceId:number;
	sellerPriceId:number;
	costServiceId:number;
	warrantyPriceId:number;
	vehicleLine:string;
	modelYear:number;
	status:string;

	constructor() {
	}
}